module.exports = __webpack_public_path__ + "static/media/6-30.b38d5a36.svg";